export default class Constants {
	public static readonly apiKeyHeaderName = 'X-Esignatur-ApiKey';
}
